exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-dropdown-menu__item.active{color:#409eff!important}", ""]);

// exports
